import { render, staticRenderFns } from "./OptionArticle.vue?vue&type=template&id=2da776d7&"
import script from "./OptionArticle.vue?vue&type=script&lang=js&"
export * from "./OptionArticle.vue?vue&type=script&lang=js&"
import style0 from "./OptionArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports